import './legend.css'
import { convertValuesToTruweatherUnits } from '../../../utils/WetDogWeatherUtils'
import { useSelector } from 'react-redux'
//
//  Takes in the colorMap and units passed form Legend.tsx, then generates the legend based on that information.
//
function LegendContent({ colorMap, units }) {
  let legend: JSX.Element[] = []

  const darkMode = useSelector((state) => state.mapState.darkMode)

  if (colorMap) {
    const colors = colorMap.colors
    const values = colorMap.values
    const visibles = colorMap.visibles

    const uniqueValues = [
      ...new Set(values.map((v) => convertValuesToTruweatherUnits(v, units))),
    ]
    const uniqueColorValues = [...new Set(colors.map((v) => v.str))]

    // 2. Build ranges from consecutive values
    for (let i = 0; i < uniqueValues.length - 1; i++) {
      if (visibles[i]) {
        const rangeStart = uniqueValues[i].toFixed(2)
        const rangeEnd = uniqueValues[i + 1].toFixed(2)

      const isLastVisibleCeilingValue = i === uniqueValues.length - 2 && (units.toLowerCase() === 'ft' || units.toLowerCase() === 'm')


        const newLegendItem = (
          <div className="flex items-center space-x-2" key={'legend-item-' + i}>
            <div
              className="w-5 h-5 rounded-sm"
              style={{ background: uniqueColorValues[i] }}
            />
            {units === 'F' ? (
              <span
                className={`text-sm ${darkMode ? 'text-white' : 'text-black'}`}
              >
                {`${parseInt(rangeStart)} – ${parseInt(rangeEnd)}`}
              </span>
            ) : (
              <span
                className={`text-sm ${darkMode ? 'text-white' : 'text-black'}`}
              >
                 {isLastVisibleCeilingValue
              ? `> ${parseInt(rangeStart)}`
              : `${parseInt(rangeStart)} – ${parseInt(rangeEnd)}`}
              </span>
            )}
          </div>
        )
        legend.push(newLegendItem)
      }
    }

    return (
      <div
        className={`legend-container ${
          darkMode ? 'bg-navigationBg' : 'bg-white'
        } pt-4 pb-4 pl-2 pr-2 rounded-2xl shadow-md space-y-2 mt-5`}
      >
        <h3
          className={`font-bold mb-2 text-sm ${
            darkMode ? 'text-white' : 'text-black'
          }`}
        >
          {`Legend (${units == 'F' ? '°F' : units})`}
        </h3>
        {legend}
      </div>
    )
  }
}

export default LegendContent
